import styled from "@emotion/styled"
import {IonToggle} from "@ionic/react"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {getEndPoint, USER_PROFILE} from "../../util/api/enpoints"
import ButtonItem from "../CommonStyles/ButtonItem";
import {updateStateOnLogout, updateUserProfile, useUserInfo} from "../../redux/slices/userSlice";
import jwt_decode from "jwt-decode";
import '../../theme/revamp.css';
import {useAuthRefresh} from "../../hooks/authenicationHook";
import {disconnected} from "../../redux/slices/signalrSlice";
import {useNavigate, useParams} from "react-router-dom";
import PageBodyContainer from "../CommonStyles/PageBodyContainer";



const PageContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  padding: 0 5px;
`

interface Params {
  eventcode: string
}

const MyAccount = () => {
  const { eventcode } = useParams()
  useAuthRefresh();

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useUserInfo()
  const eventState = useSelector((state: any) => state.event)

  const onToggleChange = (name) => (e) => {
    const url = getEndPoint(USER_PROFILE);
    dispatch(updateUserProfile({ ...user, bidanonymously:e?.target?.checked, ...user.notifications, url }));
  };

  const logUserOut = () => {
    const elementScroll = document.getElementById("scrollBody")
    if (elementScroll) {
      elementScroll.scroll(0,0)
    }

    dispatch(updateStateOnLogout())
    const token = localStorage.getItem("token")
    localStorage.removeItem("token")
    dispatch(disconnected())
    dispatch({
      type: "DISCONNECT_SIGNALR"
    })

    navigate('/' + eventcode)
  }

  const onResetPassword = () => {
    navigate('/' + eventcode + '/reset-password-account')
  }

  const onNotifications = () => {
    navigate('/' + eventcode + '/account-notifications')
  }

  const onUpdatePaymentMethod = () => {
    navigate('/' + eventcode + '/account-update-payment-method')
  }

  const onEditProfile = () => {
    navigate('/' + eventcode + '/account-profile')
  }

  const onContact = () => {
    navigate('/' + eventcode + '/contact-us')
  }

  return (
        <>
          <h1 className="as-page-title">My Account</h1>
          <div className="as-shell">
            <div className="as-menu">
              <div className="as-menu-row" onClick={onEditProfile}>
                <span className="as-menu-label">Edit My Profile</span>
                <span className="as-menu-chevron">&rsaquo;</span>
              </div>
              {(eventState.eventallowanonymousbidding) && (
                <div className="as-menu-row as-menu-row--static">
                  <span className="as-menu-label">Bid Anonymously</span>
                  <IonToggle
                      checked={user.bidanonymously}
                      onClick={onToggleChange("bidanonymously")}
                  ></IonToggle>
                </div>
              )}
              <div className="as-menu-row" onClick={onNotifications}>
                <span className="as-menu-label">Notifications</span>
                <span className="as-menu-chevron">&rsaquo;</span>
              </div>
              {(user.showupdatepaymentmethod) && (
                <div className="as-menu-row" onClick={onUpdatePaymentMethod}>
                  <span className="as-menu-label">Update Payment Method</span>
                  <span className="as-menu-chevron">&rsaquo;</span>
                </div>
              )}
              <div className="as-menu-row" onClick={onContact}>
                <span className="as-menu-label">Contact Us</span>
                <span className="as-menu-chevron">&rsaquo;</span>
              </div>
            </div>
          </div>{/* /as-shell */}
    </>
  )
}

export default MyAccount
